function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.278 16.984c1.17 4.26-1.982 8.84-7.042 10.23-5.059 1.39-10.109-.937-11.28-5.198-1.17-4.26 1.984-8.84 7.043-10.23 5.06-1.39 10.11.937 11.28 5.198z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.22 18.258c.293 1.065-.117 2.106-.916 2.326-.799.22-1.683-.466-1.976-1.531-.292-1.066.118-2.107.917-2.326.799-.22 1.683.466 1.976 1.531zM44.007 16.669c.292 1.065-.118 2.106-.917 2.326-.799.22-1.684-.466-1.976-1.532-.293-1.065.118-2.106.917-2.325.798-.22 1.683.466 1.976 1.53z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.248 23.4c5.19 2.359 7.038-1.934 7.038-1.934"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.852 18.048a.5.5 0 11-.964.265.5.5 0 01.964-.265zM43.638 16.46a.5.5 0 11-.964.264.5.5 0 01.964-.265zM36.232 43.388c-7.384 4.66-15.87 4.735-15.87 4.735s-.787-9.186 3.744-16.65c3.296-5.43 10.775-5.536 14.123-2.245 3.349 3.29 3.374 10.77-1.997 14.16z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.56 28.976C33.617 38.5 38.617 41.5 38.617 41.5M23.756 31.83C30.618 42.5 35.618 43.5 35.618 43.5M22.022 35.734c4.743 7.94 9.843 9.672 9.843 9.672M30.362 27.104C35.618 34.5 40.118 37.5 40.118 37.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.205 31.795s-8.23 2.896-14.347 1.19C3.74 31.28-.378 26.879.66 23.156c1.038-3.725 6.84-5.36 12.958-3.655 6.118 1.706 10.587 12.295 10.587 12.295z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.35 18.887c-1.495-3.006-1.6-5.978.023-7.803 2.57-2.888 8.5-1.806 13.245 2.416 4.744 4.222 4.101 15.698 4.101 15.698s-2.006-.236-4.617-.95",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.618 1.5c-3.83 3.288-.466 7.23 1 11M41.385 1.314c-4.76 1.676-3.055 6.57-3.056 10.614M39.618 55.5c0-6-3.406-7.897-6-11M40.3 33c1.535 5.8 6.7 8 9.7 7"
}));

var SvgBee = function SvgBee(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBee, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bee.78226e48.svg";
export { ForwardRef as ReactComponent };